<div class="content">
    <list-view [liste]="liste" *ngIf="liste" (onLoadEnd)="initListeActions()"></list-view>
</div>
<floating-button [listeActions]="listeActions" [isPending]="isPending"></floating-button>